export default [
  {
    path: '/interactive-case-studies/list/:categoryId?',
    name: 'interactiveCaseStudies#index',
    component: () => import('@views/interactiveCaseStudies/index'),
    meta: {
      header: true,
    },
  },
  {
    path: '/interactive-case-studies/:groupingId?',
    name: 'interactiveCaseStudies#show',
    component: () => import('@views/interactiveCaseStudies/show'),
    meta: {
      header: true,
      masteryFooter: true,
      masteryHeader: true,
    },
  },
];
